import script from "./GroupSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupSetting.vue?vue&type=script&lang=ts&setup=true"

import "./GroupSetting.vue?vue&type=style&index=0&id=58f31316&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58f31316"]])

export default __exports__